export default {
  title: 'Datos generales',
  document: 'NIE/CIF',
  reason: 'Razón Social',
  email: 'Correo Electrónico',
  address: 'Dirección',
  postalCode: 'Código Postal',
  town: 'Población',
  city: 'Provincia',
  country: 'País',
  inscription: 'Inscripción Reg. Mercantil',
  accountAssignedId: 'Código Cuenta Contable',
  irpf: {
    retention: 'Retención IRPF',
    notSupported: 'No soporta IRPF'
  },
  greenPoint: {
    label: 'Punto Verde',
    notSupported: 'No soportado',
    included: 'Incluido en el importe',
    brokenDown: 'Desglosado a nivel de línea'
  },
  subjectTo: 'Sujeto al Régimen Especial de Criterio de Caja',
  help: 'Empresa sujeta al Régimen Especial de Criterio de Caja, de acuerdo al Art. 23 de la Ley 14/2013',
  ticketbaiRequired: 'Notificar a TicketBAI',
  headingBizkaia: 'Epígrafe',
  headingListBizkaia: 'Descargar listado de epígrafes',
  ticketbaiRequiredHelp: 'Norma Foral 13/2021, de 21 de abril (Álava). Norma Foral 3/2020, de 6 de noviembre (Guipúzcoa), Norma Foral 8/2023, de 22 de noviembre (Vizcaya)',
  siiRequired: 'Notificar al SII (LRFE)',
  siiRequiredHelp: `<br>El período de liquidación de registro en el SII, se corresponderá con el año y mes de la fecha de devengo de la factura. <br>La fecha de expedición y de registro en el SII será la fecha de emisión de la factura.`,
  modal: {
    text: 'Los datos han sido actualizados con éxito.'
  },
  terms: 'Términos y condiciones del contrato',
  version: {
    title: 'Sistema Efactura',
    front: 'Versión Front: ',
    core: 'Versión Core: ',
    back: 'Versión API: '
  },
  verifactu: {
    title: 'VERI*FACTU',
    yesOption: 'Sí',
    noOption: 'No',
    exemptOption: 'Exento',
    exemptReasonPlaceholder: 'Motivo de exención',
    modal: {
      info: 'Una vez activada esta opción, se enviarán los ficheros inmediatamente después de la emisión de cada factura.\n\nNo podrá cambiar de opción hasta el 1 de enero del año siguiente, según lo indica la ley\n\nSi la factura original ya ha sido enviada desde otro ERP, es posible que se dupliquen las comunicaciones con la AEAT. Asegúrese de esto antes de enviar la factura.',
      link: 'Más información'
    },
    lockedTooltip: 'No podrá cambiar de opción hasta el 1 de enero del año siguiente',
    rdTooltip: 'Real Decreto 254/2025, de 1 de abril, por el que se modifica el Real Decreto 1007/2023, de 5 de diciembre'
  },
  eReporting: 'E-REPORTING',
  eReportingError: 'Solo se puede seleccionar una opción de E-REPORTING'
}
